<p-contextMenu #rowMenu [model]="menuItems" appendTo="body"></p-contextMenu>
<p-menu #actionMenu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>

<p-table
  [value]="rows"
  [loading]="loading"
  [scrollable]="true"
  [scrollHeight]="scrollHeight"
  styleClass="p-datatable-sm"
  [contextMenu]="hasActions ? rowMenu : null"
  [(contextMenuSelection)]="selectedRow"
  (onContextMenu)="onRowContextMenu($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Status</th>
      <th>Description</th>
      <th pSortableColumn="transaction_date">Date <p-sortIcon field="transaction_date"></p-sortIcon></th>
      <th>Due</th>
      <th>Reference</th>
      <th class="text-right">Credit</th>
      <th class="text-right">Debit</th>
      <th>Method</th>
      <th *ngIf="hasActions" style="width: 3rem"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-t>
    <tr [pContextMenuRow]="t">
      <td><p-tag [value]="t.status | uppercase" [severity]="statusSeverity(t.status)"></p-tag></td>
      <td>{{ t.transaction_description || t.transaction_type }}</td>
      <td class="white-space-nowrap">{{ t.transaction_date | date: 'yyyy-MM-dd' }}</td>
      <td class="white-space-nowrap">{{ t.transaction_date_due ? (t.transaction_date_due | date: 'yyyy-MM-dd') : '-' }}</td>
      <td>{{ t.reference }}</td>
      <td class="text-right text-green-600 white-space-nowrap">
        <span *ngIf="t.transaction_type === 'credit'">{{ t.amount_incl | currency: t.currency || 'ZAR' : 'symbol-narrow' }}</span>
      </td>
      <td class="text-right text-red-600 white-space-nowrap">
        <span *ngIf="t.transaction_type === 'debit'">{{ t.amount_incl | currency: t.currency || 'ZAR' : 'symbol-narrow' }}</span>
      </td>
      <td>{{ t.transaction_method || '-' }}</td>
      <td *ngIf="hasActions">
        <button
          pButton
          type="button"
          icon="pi pi-ellipsis-v"
          class="p-button-text p-button-rounded p-button-sm"
          aria-label="Transaction actions"
          (click)="openMenu(t); actionMenu.toggle($event)"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="hasActions ? 9 : 8" class="text-center p-3 text-600">{{ emptyMessage }}</td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog key="shareTransactionVoid" appendTo="body"></p-confirmDialog>
